import React, { useEffect, useState } from "react";
import { withStyles, makeStyles } from "@material-ui/core/styles";
import {
  Grid,
  Table,
  TableBody,
  TableCell,
  TableRow,
  TableHead,
  TableContainer,
  withWidth,
  Tooltip,
} from "@material-ui/core";
import { useQuery } from "@apollo/react-hooks";
import { dashboardQuery } from "../../queries/dashboardQuery";
import {
  getBalance,
  onGetInterestRate,
  getContractBalance,
  // onGetTotalStakedToken,
} from "../../store/actions/dashboardActions";
import { PHNX_STAKING_ADDRESS } from "../../contracts/phnxStaking";
import { connect } from "react-redux";
import Web3 from "web3";
import "./style.css";
import { GetDashboardData } from "../../Config/graphQL";

const useStyles = makeStyles((theme) => ({
  table: {
    padding: "10px",
    backgroundColor: theme.palette.card.main,
  },
  container: {
    maxHeight: 270,
  },
  tableHeader: {
    color: "#9A9A9A",
    fontWeight: "bold",
    // fontSize: "1rem",
    backgroundColor: theme.palette.card.main,
  },
  tableBody: {
    color: "#828282",
    fontSize: "1rem",
  },

  myPara: {
    fontSize: 16,
    "@media (min-width: 2400px)": {
      fontSize: 24,
    },
  },

  myHeading: {
    fontSize: 20,
    "@media (min-width: 2400px)": {
      fontSize: 36,
    },
  },
}));

const Dashboard = (props) => {
  const classes = useStyles();
  const [loadOnStake, setLoadOnStake] = useState(false);
  const [stakes, setStakes] = useState([]);
  const [stakesHistory, setStakesHistory] = useState([]);
  const [data, setData] = useState(null);
  const [graphData, setGraphData] = useState([]);

  const stakingInformation = [
    { stakedPHNX: 2000, releaseDate: "12/03/2020", spotTokens: 20 },
    { stakedPHNX: 2500, releaseDate: "12/03/2020", spotTokens: 25 },
    { stakedPHNX: 4000, releaseDate: "12/03/2020", spotTokens: 40 },
    { stakedPHNX: 1000, releaseDate: "12/03/2020", spotTokens: 10 },
  ];

  const StyledTableRow = withStyles((theme) => ({
    root: {
      "&:nth-of-type(odd)": {
        backgroundColor: theme.palette.action.hover,
      },
    },
  }))(TableRow);

  useEffect(() => {
    // let addresss = localStorage.getItem("localaddress");
    if (props.network != 1) {
      setData([]);
      return;
    }
    (async () => {
      if (props.address) {
        let res = await GetDashboardData(props.address);
        // GetDashboardData();
        setGraphData(res);
      }
    })();
  }, [props.address, props.balance, props.stakeLoading, props.network]);

  useEffect(() => {
    setLoadOnStake(false);
  }, [loadOnStake]);

  useEffect(() => {
    props.getContractBalance(PHNX_STAKING_ADDRESS);
    // console.log("props.contractBalance", props.contractBalance);
    // console.log("props.network getContractBalance", props.network);
  }, [props.balance, props.network]);

  useEffect(() => {
    if (props.network != 1) {
      setStakes([]);
      setStakesHistory([]);
      return;
    }
    // if (!loading) {
    if (data && data.user) {
      setStakes(data?.user?.stake?.filter((_stake) => _stake.altQuantity > 0));
      setStakesHistory(
        data?.user?.history?.filter(
          (_stake) =>
            Math.ceil(
              parseFloat(_stake.id) +
                parseFloat(_stake.durationTimestamp) -
                new Date() / 1000
            ) <= 0
        )
      );
    } else {
      setStakes([]);
      setStakesHistory([]);
    }
    // }
  }, [data, props.network]);

  // useEffect(() => {
  //   if (props.address) {
  //     refetch();
  //   }
  // }, [props.address, props.balance, props.network]);

  useEffect(() => {
    if (graphData && graphData.user) {
      // console.log("graphData Unstake", graphData.user.stake);

      [...graphData.user.stake].sort((a, b) => {
        let timestamp = Math.floor(+new Date() / 1000);

        let aa =
          Number(a.initiationTimestamp) +
          Number(a.durationTimestamp) -
          timestamp;
        let bb =
          Number(b.initiationTimestamp) +
          Number(b.durationTimestamp) -
          timestamp;

        return aa - bb;
      });

      setData(graphData);
    }
  }, [graphData]);

  const date = new Date();

  return (
    <Grid style={{ height: "100%" }} container justify="space-between">
      <Grid
        item
        xs={12}
        sm={12}
        md={6}
        lg={6}
        className={classes.table}
        style={{
          // boxShadow: "0 12px 45px #c3c3c396",
          boxShadow:
            "0px 2px 1px -1px rgba(0,0,0,0.2) , 0px 1px 1px 0px rgba(0,0,0,0.14) ,0px 1px 3px 0px rgba(0,0,0,0.12)",
          borderRadius: "8px",
        }}
      >
        <div className={classes.myHeading} style={{ margin: " 32px 12px" }}>
          <span style={{ color: "#9A9A9A" }}> Staking</span>{" "}
          <span style={{ color: "#EA8604" }}>information</span>
        </div>
        <TableContainer className={classes.container}>
          <Table stickyHeader>
            <TableHead>
              <TableRow>
                <TableCell
                  className={[classes.myPara, classes.tableHeader]}
                  align="left"
                >
                  Staked PHNX
                </TableCell>

                <TableCell
                  className={[classes.myPara, classes.tableHeader]}
                  align="left"
                >
                  Release date
                </TableCell>
              </TableRow>
            </TableHead>
            {stakes.length === 0 ? (
              <TableBody>
                <StyledTableRow>
                  <TableCell className={classes.tableBody} align="left">
                    -
                  </TableCell>
                  <TableCell className={classes.tableBody} align="left">
                    -
                  </TableCell>
                </StyledTableRow>
              </TableBody>
            ) : (
              <TableBody>
                {stakes.map((_stake) => {
                  const daysleft = Math.ceil(
                    (parseFloat(_stake.initiationTimestamp) +
                      parseFloat(_stake.durationTimestamp) -
                      Date.now() / 1000) /
                      86400
                  );

                  // console.log("days left ===>>>", daysleft);

                  var calculatedDate = new Date();
                  if (daysleft > 0) {
                    calculatedDate.setDate(date.getDate() + daysleft);
                  }

                  const releaseDate =
                    daysleft > 0
                      ? `${calculatedDate.getDate()}/${
                          calculatedDate.getMonth() + 1
                        }/${calculatedDate.getFullYear()}`
                      : `${calculatedDate.getDate()}/${
                          calculatedDate.getMonth() + 1
                        }/${calculatedDate.getFullYear()}`;

                  return (
                    <StyledTableRow>
                      <Tooltip title={Web3.utils.fromWei(_stake.altQuantity)}>
                        <TableCell className={classes.tableBody} align="left">
                          {
                            Web3.utils
                              .fromWei(_stake.altQuantity)
                              .toString()
                              .match(/^-?\d+(?:\.\d{0,4})?/)[0]
                          }
                        </TableCell>
                      </Tooltip>
                      <TableCell className={classes.tableBody} align="left">
                        {releaseDate}
                      </TableCell>
                    </StyledTableRow>
                  );
                })}
              </TableBody>
            )}
          </Table>
        </TableContainer>
      </Grid>
      <Grid
        item
        xs={12}
        sm={12}
        md={6}
        lg={6}
        className={classes.table}
        style={
          props.width === "xs" || props.width === "sm"
            ? {
                // boxShadow: "0 12px 45px #c3c3c396",
                boxShadow:
                  "0px 2px 1px -1px rgba(0,0,0,0.2) , 0px 1px 1px 0px rgba(0,0,0,0.14) ,0px 1px 3px 0px rgba(0,0,0,0.12)",
                marginTop: "12px",
                borderRadius: "8px",
              }
            : {
                // boxShadow: "0 12px 45px #c3c3c396",
                boxShadow:
                  "0px 2px 1px -1px rgba(0,0,0,0.2) , 0px 1px 1px 0px rgba(0,0,0,0.14) ,0px 1px 3px 0px rgba(0,0,0,0.12)",
                maxWidth: "48%",
                borderRadius: "8px",
              }
        }
        className={classes.table}
      >
        <div className={classes.myHeading} style={{ margin: " 32px 12px" }}>
          <span style={{ color: "#9A9A9A" }}>Completed</span>{" "}
          <span style={{ color: "#EA8604" }}>stakes</span>
        </div>
        <TableContainer className={classes.container}>
          <Table stickyHeader>
            <TableHead>
              <TableRow>
                <TableCell
                  className={[classes.myPara, classes.tableHeader]}
                  align="left"
                >
                  Staked PHNX
                </TableCell>

                <TableCell
                  className={[classes.myPara, classes.tableHeader]}
                  align="left"
                >
                  Spot tokens
                </TableCell>
              </TableRow>
            </TableHead>
            {stakesHistory?.length === 0 ? (
              <TableBody>
                <StyledTableRow>
                  <TableCell className={classes.tableBody} align="left">
                    -
                  </TableCell>
                  <TableCell className={classes.tableBody} align="left">
                    -
                  </TableCell>
                </StyledTableRow>
              </TableBody>
            ) : (
              <TableBody>
                {stakesHistory?.map((_stakeHistory) => {
                  const altQuantity = Web3.utils.fromWei(
                    _stakeHistory.altQuantity
                  );
                  const rewardAmount = Web3.utils.fromWei(
                    _stakeHistory.rewardAmount
                  );
                  return (
                    <StyledTableRow>
                      <Tooltip title={altQuantity}>
                        <TableCell className={classes.tableBody} align="left">
                          {
                            altQuantity
                              .toString()
                              .match(/^-?\d+(?:\.\d{0,4})?/)[0]
                          }
                        </TableCell>
                      </Tooltip>
                      <Tooltip title={rewardAmount}>
                        <TableCell className={classes.tableBody} align="left">
                          {
                            rewardAmount
                              .toString()
                              .match(/^-?\d+(?:\.\d{0,4})?/)[0]
                          }
                        </TableCell>
                      </Tooltip>
                    </StyledTableRow>
                  );
                })}
              </TableBody>
            )}
          </Table>
        </TableContainer>
      </Grid>
    </Grid>
  );
};

const mapStateToProps = (state) => {
  return {
    address: state.layoutReducer.address,
    balance: state.dashboardReducer.balance,
    interest: state.dashboardReducer.interest,
    stakedPhnx: state.dashboardReducer.stakedPhnx,
    // portalLoading: state.dashboardReducer.loading,
    activePortal: state.dashboardReducer.activePortal,
    portalInterestList: state.dashboardReducer.interestList,
    contractBalance: state.dashboardReducer.contractBalance,
    network: state.layoutReducer.network,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getBalance: (address) => dispatch(getBalance(address)),
    getContractBalance: (address) => dispatch(getContractBalance(address)),
    // checkRemainingTransactions: (address) => dispatch(checkRemainingTransactions(address)),
    onGetInterestRate: () => dispatch(onGetInterestRate()),
    // onGetTotalStakedToken: () => dispatch(onGetTotalStakedToken())
  };
};

export default withWidth()(
  connect(mapStateToProps, mapDispatchToProps)(Dashboard)
);
